module.exports = "<p>monitored-train-summary-upgraded works!</p>\n";